import {
  Container,
  Typography,
  Box,
  Stack,
  Alert,
  AlertTitle,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/common/Header";
import LoadingAnimation from "../components/Lottie/LoadingAnimation";
import configData from "../Config";
import { useNavigate, useLocation } from "react-router-dom";
import { apis } from "../services/apiService";
import Backdrop from "../components/common/Backdrop";
import AlertPopup from "../components/common/AlertPopup";
import { constant, loggerStore, logout, multiDecryption } from "../utils/utils";
import useSelector from "../store/selector";
export default function Loading() {
  const { getRecoilVal, setRecoilVal } = useSelector();
  const navigate = useNavigate();
  let location = useLocation();
  const [finalErr, setFinalErr] = useState("");
  const { t } = useTranslation();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const reqData = {
          aid: location.state.AppId,
        };
        let resp = await apis.postApi(
          configData.API_URL + "BRE/RunBRE",
          reqData
        );
        let result = await resp?.json();
        if (resp?.status === 200) {
          let data = {
            AppId: location.state.AppId,
            ALimit: result?.data,
          };
          navigate("/eligible-amount", { state: data });
          loggerStore(
            location?.state?.AppId,
            `BRE Run successfully = ${JSON?.stringify(result)}`,
            "Success"
          );
        }
      } catch (error) {
        const errorResult = JSON.parse(error?.message);
        setFinalErr(errorResult?.statusMessage);
        loggerStore(
          location?.state?.AppId,
          `BRE Run failed = ${JSON?.stringify(errorResult)}`,
          "error"
        );
      }
    };
    fetchData();
  }, []);

  return (
    <Container maxWidth={false} className="container_Th">
      <Header showBar={false} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "90vh",
        }}
      >
        <LoadingAnimation />
        {!finalErr ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "-50px",
            }}
          >
            <Typography
              variant="h3"
              color="black"
              sx={{ mt: 1, mb: 2, fontWeight: "bold" }}
            >
              {t("Please Wait")}
            </Typography>
            <Typography variant="p" color="info" sx={{ textAlign: "center" }}>
              {t(
                "Your Loan Application is under process, this screen will be refreshed shortly."
              )}
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "-50px",
            }}
          >
            <Typography
              variant="p"
              className="errorMsg_Th"
              sx={{ textAlign: "center" }}
            >
              {finalErr}
            </Typography>
          </Box>
        )}
      </Box>
    </Container>
  );
}
